<template>
  <div class="form-page">
    <!-- variants + range slider -->
    <div
      v-for="(value, index) in shortcuts"
      :key="index"
      class="form-button form-var"
      :name="history[currentStep].name"
      @click="handleSelect(value)"
    >
      {{
        `${value.toLocaleString()} ${+value === 1 && [4, 5].indexOf(additionalParams.country) > -1 ? 'mes' : currency}`
      }}
    </div>
    <div class="other-value" v-if="history[currentStep].field.tooltip">
      <p class="other-value-text">
        {{ history[currentStep].field.tooltip }}
      </p>
    </div>
    <div class="form-input__wrap form-input__wrap--slider">
      <input
        type="tel"
        :name="history[currentStep].name"
        @keydown="handleKeydown"
        @blur="handleBlur"
        v-model="inputVal"
        inputmode="number"
        class="form-input form-inputWithRange"
        required
      />
      <span class="form-input-floating-label form-input-floating-label-inputWithRange">{{
        history[currentStep].field.placeholder
      }}</span>
      <span class="form-input__line"></span>
      <span class="form-input__after">{{ currency }}</span>
      <input
        class="form-input-range"
        @click="handleClick"
        type="range"
        v-model="inputVal"
        :name="history[currentStep].name + '_slider'"
        v-bind:style="{
          background: `linear-gradient(90deg, ${mainColor} ${sliderBulletPos}%, #F3F3F3 ${sliderBulletPos}%)`
        }"
        :min="limits.min"
        :max="limits.max"
        :step="limits.step"
      />
    </div>
    <RemoteAgreements
      v-if="history[currentStep].name === 'loan_sum_repeat' && country === 14"
      :show-error="!accepted && history[currentStep].showCheckboxError"
      :value="!!accepted"
      @change="checkboxChanged"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import RemoteAgreements from '../assetComponents/RemoteAgreements.vue'

export default {
  name: 'InputWithSlider',
  components: { RemoteAgreements },
  data () {
    return {
      inputVal: 0,
      lastInput: 0,
      mainColor: '#5bb73b'
    }
  },
  mounted () {
    let midVal = this.history[this.currentStep].value || Math.floor((this.limits.max + this.limits.min) / 2)
    const shortcuts = this.history[this.currentStep].field.shortcuts
    let value
    if (this.history[this.currentStep].value) {
      value = this.history[this.currentStep].value
    } else if (!value && this.limits && typeof this.limits.default === 'number') {
      value = this.limits.default
      this.$store.commit('UPDATE_FIELD', { isValid: true, value })
    } else {
      value = (shortcuts && shortcuts[0]) || midVal
    }
    this.inputVal = value
    this.lastInput = this.inputVal
    this.$nextTick(function () {
      let newSliderColor = this.$store.getters.getStyle(document.getElementsByClassName('form-buttons__next')[0], 'background-color')
      if (newSliderColor) this.mainColor = newSliderColor
    })
  },
  watch: {
    inputVal: function (val, oldVal) {
      this.$store.commit('UPDATE_FIELD', { isValid: true, value: val })
      this.$store.dispatch('sendCrezuEvent', { id: 5, data: { sub4: 'loanSumChanged', sub5: val } })
    }
  },
  computed: {
    sliderBulletPos () { return (this.inputVal - this.limits.min) / (this.limits.max - this.limits.min) * 100 },
    ...mapState({
      history: state => state.history,
      currentStep: state => state.currentStep,
      country: state => state.additionalParams.country,
      limits: state => {
        if (state.additionalParams.exp_flow === '74-1' && state.history[currentStep].name === 'loan_sum') {
          if (state.additionalParams.country === 2) {
            return {
              step: 100,
              min: 100,
              max: 20000
            }
          } else if (state.additionalParams.country === 14) {
            return {
              step: 100,
              min: 100,
              max: 10000
            }
          }
        }
        if (state.additionalParams.exp_flow === '0062.1-B' && state.history[currentStep].name === 'loan_sum' && state.additionalParams.country === 1) {
          return {
            step: 100,
            min: 100,
            max: 5000
          }
        }
        return state.history[state.currentStep].field.limits || {}
      },
      shortcuts: state => {
        if (state.additionalParams.exp_flow === '74-1' && state.history[currentStep].name === 'loan_sum') {
          if (state.additionalParams.country === 2) {
            return [15000, 10000, 5000]
          } else if (state.additionalParams.country === 14) {
            return [15000, 10000, 5000]
          }
        }
        if (state.additionalParams.exp_flow === '0062.1-B' && state.history[currentStep].name === 'loan_sum') return [500, 300, 100]
        return state.history[state.currentStep].field.shortcuts
      },
      currency: state => state.history[state.currentStep].field.currency,
      additionalParams: state => state.additionalParams,
      accepted: state => state.additionalParams.is_terms_accepted || false
    })
  },
  methods: {
    handleClick (e) {
      let min = this.limits.min
      let max = this.limits.max
      let step = this.limits.step
      let val = (((e.offsetX + ((e.offsetX > e.target.clientWidth / 2) ? 10 : -10)) / (e.target.clientWidth)) * (max - min) + min)
      if (this.inputVal === this.lastInput) {
        let temp = min
        while (temp < val) {
          temp += step
        }
        this.inputVal = ((temp - val) > step / 2) ? (temp - step) : temp
      }
      if (this.inputVal > this.limits.max) this.inputVal = this.limits.max
      if (this.inputVal < this.limits.min) this.inputVal = this.limits.min
      this.lastInput = this.inputVal
    },
    handleKeydown (e) {
      if (e.keyCode === 13) {
        this.$store.dispatch('nextStepPrepare', +1)
      }
    },
    handleBlur () {
      if (this.inputVal > this.limits.max) this.inputVal = this.limits.max
      if (this.inputVal < this.limits.min) this.inputVal = this.limits.min
    },
    handleSelect (val) {
      this.$store.dispatch('sendCrezuEvent', { id: 5, data: { sub4: 'loanSumChanged', sub5: val } })
      this.$store.commit('UPDATE_FIELD', { isValid: true, value: val })
      this.$store.dispatch('nextStepPrepare', +1)
    },
    checkboxChanged (e) {
      this.$store.commit('CHANGE_ADDITIONAL_PARAMS', { is_terms_accepted: e ? 'on' : '' })
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.other-value {
  width: 100%;
}
.other-value-text {
  margin: 10px auto;
  font-size: 16px;
}
.form-inputWithRange {
  text-align: left !important;
}
</style>



// WEBPACK FOOTER //
// src/components/fields/InputWithSlider.vue